// React import not needed with new JSX transform
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './store';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { MainLayout } from './components/layout/MainLayout';
import { LoginPage } from './pages/auth/LoginPage';
import { UnauthorizedPage } from './pages/auth/UnauthorizedPage';
import HomePage from './pages/HomePage';
import { MachinesPage } from './pages/machines/MachinesPage';
import { MachineCreatePage } from './pages/machines/MachineCreatePage';
import { MachineDetailPage } from './pages/machines/MachineDetailPage';
import { MachineEditPage } from './pages/machines/MachineEditPage';
import { MachineQRCodePage } from './pages/machines/MachineQRCodePage';
import { ManualDetailPage, ManualPhotoUploadPage, ManualsOverviewPage } from './pages/manuals';
import { SparePartsOverviewPage, OperatingSuppliesOverviewPage, ToolsOverviewPage } from './pages/inventory';
import UserManagementPage from './pages/users/UserManagementPage';
import NotificationManagementPage from './pages/notifications/NotificationManagementPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarWidth: 'thin',
          scrollbarColor: '#B7B7B7 #F5F5F5',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#F5F5F5',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#B7B7B7',
            borderRadius: '4px',
          },
        },
      },
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              
              {/* Protected routes */}
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<HomePage />} />
                {/* Machine routes */}
                <Route path="machines" element={<MachinesPage />} />
                <Route path="machines/new" element={<MachineCreatePage />} />
                <Route path="machines/:id" element={<MachineDetailPage />} />
                <Route path="machines/:id/edit" element={<MachineEditPage />} />
                <Route path="machines/:id/qr" element={<MachineQRCodePage />} />
                
                {/* Manual routes */}
                <Route path="manuals" element={<ManualsOverviewPage />} />
                <Route path="manuals/:id" element={<ManualDetailPage />} />
                <Route path="manuals/:id/upload" element={<ManualPhotoUploadPage />} />

                {/* Inventory routes */}
                <Route path="spare-parts" element={<SparePartsOverviewPage />} />
                <Route path="operating-supplies" element={<OperatingSuppliesOverviewPage />} />
                <Route path="tools" element={<ToolsOverviewPage />} />

                {/* User management routes */}
                <Route path="users" element={<UserManagementPage />} />

                {/* Notification management routes */}
                <Route path="notifications" element={<NotificationManagementPage />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
